module.exports = __webpack_public_path__ + "img/badge-3d-fill.791cf697.svg";